// // The Vue build version to load with the `import` command
// // (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
// import App from './App'
// import router from './router'
// import store from './store'
// import './assets/flexible/flexible'
// import vantUi from './config/components'
//
// Vue.use(vantUi)
//
// Vue.config.productionTip = false
//
// /* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: {App},
//   template: '<App/>'
// })

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'

import '@/assets/css/app.css'
// import './assets/font/iconfont.css'
import "@/assets/flexible/flexible.js";

// document.title = process.env.VUE_APP_TITLE;
Vue.config.productionTip = false;


import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style (>= Swiper 6.x) swiper版本大于等于6.x时引用
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper,)

import apis from './apis'

Vue.prototype.$apis = apis
Vue.prototype.$axios = axios
import vantUi from './config/components'
import 'vant/lib/index.css';
Vue.use(vantUi)

// import { Calendar } from 'element-ui'
// 设置语言
// 引入组件
// Vue.component(Calendar.name, Calendar)
// import 'element-ui/lib/theme-chalk/index.css';


import Bus from './bus' //这是我的路径，正确引用你们的路径
Vue.prototype.$bus = Bus
//身份证接口线上请求前缀
Vue.prototype.$IDCARD_ROOT = process.env.VUE_APP_API_IDCARD_ROOT
// console.log(111,process.env.VUE_APP_TITLE);
// console.log(222,process.env.VUE_APP_API_IDCARD_ROOT);




//注册全局组件
import pageLogo from '@/views/mobile/comp/pageLogo.vue'
import pageTitle from '@/views/mobile/comp/pageTitle.vue'
import footBtn from '@/views/mobile/comp/foot-btn'
Vue.component('pageLogo',pageLogo)
Vue.component('pageTitle',pageTitle)
Vue.component('footBtn',footBtn)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});




// WEBPACK FOOTER //
// ./src/main.js
